/* Bootstraps grid-card quick-add forms with the theme's native classes:
   - theme.QtySelector handles +/-, step snapping, min clamp
   - theme.AjaxProduct intercepts submit and POSTs to /cart/add.js
   - CartDrawer auto-opens on `ajaxProduct:added` event (already wired)
   No custom logic needed beyond hooking these up per form. */
(() => {
  'use strict';

  const init = (form) => {
    if (form.dataset.qInit === '1') return;
    if (!window.theme) return;
    form.dataset.qInit = '1';

    if (theme.QtySelector) {
      form.querySelectorAll('.js-qty__wrapper').forEach((q) => {
        new theme.QtySelector(q, { namespace: '.gridQuickAdd' });
      });
    }
    if (theme.AjaxProduct) new theme.AjaxProduct(form);
  };

  const initAll = (scope) => {
    (scope || document).querySelectorAll('.grid-product__quick-add-form').forEach(init);
  };

  const syncInCartState = (cart) => {
    const ids = {};
    if (cart && cart.items) {
      cart.items.forEach((item) => { ids[item.product_id] = true; });
    }
    document.querySelectorAll('.grid-product[data-product-id]').forEach((tile) => {
      const btn = tile.querySelector('.ad_to_cart');
      if (!btn) return;
      btn.classList.toggle('is-in-cart', ids[tile.dataset.productId] === true);
    });
  };

  const refreshInCartState = () => {
    fetch((theme.routes && theme.routes.cart) || '/cart.js', { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then(syncInCartState)
      .catch(() => {});
  };

  document.addEventListener('ajaxProduct:added', refreshInCartState);

  document.addEventListener('cart:updated', (evt) => {
    if (evt.detail && evt.detail.cart) syncInCartState(evt.detail.cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  // Auto-init for forms injected later (paginate, predictive search, etc.).
  new MutationObserver((mutations) => {
    mutations.forEach((m) => {
      m.addedNodes.forEach((n) => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches && n.matches('.grid-product__quick-add-form')) init(n);
        else initAll(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
